"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputContainer = exports.Input = exports.RangeInput = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const rc_slider_1 = __importDefault(require("rc-slider"));
exports.Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px ${props => props.theme.spacing.s2}px ${props => props.theme.spacing.s6}px
    ${props => props.theme.spacing.s2}px;
`;
exports.RangeInput = (0, styled_components_1.default)(rc_slider_1.default) `
  .rc-slider-handle {
    width: ${props => props.theme.constants.blockHeight.s1}px;
    height: ${props => props.theme.constants.blockHeight.s1}px;
    margin-top: -${props => props.theme.constants.blockHeight.m0}px;
    border: 1px solid ${props => props.theme.palette.LIGHT_GRAY_90};
    background: ${props => props.theme.palette.LIGHT_GRAY_20};
    opacity: 1;
    &:hover {
      border: 1px solid ${props => props.theme.palette.ORANGE_100};
      outline: ${props => props.theme.spacing.s1}px solid ${props => props.theme.palette.ORANGE_40};
    }
  }

  .rc-slider-handle-1 {
    ${props => props.minValue && `left: 9px !important;`}
    ${props => props.fromAtMax && `left: calc(100% - 9px) !important;`}
  }

  .rc-slider-handle-2 {
    ${props => props.maxValue && `left: calc(100% - 9px) !important;`}
    ${props => props.toAtMin && `left: 9px !important;`}
  }

  .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
    border: 1px solid ${props => props.theme.palette.LIGHT_GRAY_90};
    box-shadow: 0 0 0 ${props => props.theme.spacing.s2}px rgba(204, 223, 237, 0.7);

    &:hover {
      border: 1px solid ${props => props.theme.palette.LIGHT_GRAY_90};
      outline: none;
    }
  }

  .rc-slider-track {
    background: ${props => props.theme.palette.LIGHT_GRAY_90};
  }

  .rc-slider-rail {
    background: ${props => props.theme.palette.LIGHT_GRAY_90};
  }
`;
exports.Input = styled_components_1.default.input `
  width: ${props => props.theme.constants.blockHeight.s13}px;
  height: ${props => props.theme.constants.blockWidth.s4}px;
  border: 1px solid ${props => props.theme.palette.LIGHT_GRAY_90};
  font-size: ${props => props.theme.typography.size.s2}px;
  line-height: ${props => props.theme.typography.lineHeight.s6}px;
  text-align: center;

  &:hover {
    border: 1px solid ${props => props.theme.palette.ORANGE_100};
    outline: ${props => props.theme.spacing.xs1}px solid ${props => props.theme.palette.ORANGE_40};
  }

  &:focus {
    border: 1px solid ${props => props.theme.palette.ORANGE_100};
    outline: ${props => props.theme.spacing.xs1}px solid ${props => props.theme.palette.ORANGE_40};
  }
`;
exports.InputContainer = styled_components_1.default.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing.s6}px;
`;
exports.default = {
    Container: exports.Container,
    RangeInput: exports.RangeInput,
    Input: exports.Input,
    InputContainer: exports.InputContainer
};
